/* eslint-disable no-console */
import { getLocale, getLocaleCountryCode } from "./utils/locale";
import environment, { electronOnly } from "src/utils/environment";

const remote = window.require("@electron/remote");
const { app } = remote;

export default function onStart(persistor) {
  electronOnly(() => {
    window.browserWindow = remote.getCurrentWindow();
    remote.getCurrentWebContents().openDevTools();
  });

  window.clearSession = async () => {
    await persistor.purge();

    electronOnly(() => {
      remote.getCurrentWebContents().session.clearStorageData();
      app.relaunch();
      app.quit();
    });
  };

  console.log("Country code:", getLocaleCountryCode());
  console.log("Used locale", getLocale());
  // console.log("PID =", window.process?.pid || "unknown");
}
